const MessageBubble = ({ role, text, timestamp }) => {
  const isUser = role === "user";

  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-[85%] md:max-w-[70%] rounded-2xl px-4 py-3 shadow-sm ${
          isUser
            ? "bg-green-600 text-white rounded-br-md"
            : "bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700 rounded-bl-md"
        }`}
      >
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{text}</p>
        {timestamp && (
          <p className={`mt-2 text-[11px] ${isUser ? "text-green-100" : "text-gray-500 dark:text-gray-400"}`}>
            {timestamp}
          </p>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
